// @flow
import React, { PureComponent } from 'react';

import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import SelectInput from 'components/fragments/input/SelectInput';
import TextInputMaterial from 'components/fragments/input/material/TextInputMaterial';
import Loading from 'components/fragments/Loading';

import { validateEmail, validatePhone } from 'utils/validatorUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';

import type { ContactFormType } from 'types/ContactForm';
import type { Status } from 'types/Status';

export type StateProps = {
  accreditations: Array<{ label: string, value: string }>,
  contactForm: Array<ContactFormType>,
  sendStatus: Status,
  fetchStatus: Status
};

export type DispatchProps = {
  postContactForm: (formInputs: Object, id: number) => void,
  fetchContactForm: () => void
};

type Props = {
  location: any,
  history: any
} & StateProps &
  DispatchProps;

type State = {
  isTouched: boolean,
  name: string | null,
  surname: string | null,
  media: string | null,
  fonction: string | null,
  email: string | null,
  phone: string | null,
  object: string,
  evenements: string[],
  message: string,
  error: string
};

class ContactFormAccreditations extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    isTouched: false,
    name: null,
    surname: null,
    media: null,
    fonction: null,
    email: null,
    phone: null,
    evenements: [],
    object: "Demande d'accréditation",
    message: '',
    error: ''
  };

  componentDidMount = () => {
    const { fetchContactForm } = this.props;

    fetchContactForm();
  };

  _handleChange = (name: string, value: string) => {
    const { evenements } = this.state;

    if (name === 'evenements') {
      let newEvents = [];
      if (evenements.includes(value)) {
        newEvents = evenements.filter(item => item !== value);
      } else {
        newEvents = [...evenements, value];
      }
      this.setState({ [name]: newEvents, isTouched: true });
      return;
    } else {
      this.setState({ [name]: value });
    }
  };

  setMessage = (e: any) => {
    const message = e.target.value;
    this.setState({ message });
  };

  isFormValid = () => {
    const { object, fonction, media, name, surname, email, phone, evenements } = this.state;

    if (
      object === null ||
      object === '' ||
      name === null ||
      name === '' ||
      surname === null ||
      surname === '' ||
      fonction === null ||
      fonction === '' ||
      media === null ||
      media === '' ||
      email === null ||
      !validateEmail(email) ||
      phone === null ||
      !validatePhone(phone) ||
      evenements === []
    ) {
      return false;
    }

    return true;
  };

  joinEvents = () => {
    const { evenements } = this.state;

    let newEvents = evenements
      .slice(0, evenements.length - 1)
      .map(event => `"${event}"`)
      .join(', ');
    newEvents = `${newEvents} et "${evenements[evenements.length - 1]}"`;

    return newEvents;
  };

  handleSubmit = (e: MouseEvent) => {
    e.preventDefault();
    const { postContactForm } = this.props;
    const { name, surname, media, fonction, phone, email, evenements, object } = this.state;

    this.setState({ error: '', isTouched: true });

    if (this.isFormValid()) {
      const accreditationEvenement =
        evenements.length === 1 ? `l'évènement "${evenements[0]}".` : `les évènements ${this.joinEvents()}`;
      const accreditationTitle = evenements.join(' | ');

      const formId = this._getFormId();

      // eslint-disable-next-line
      const formData = {
        'accreditation-nom': name ?? '',
        'accreditation-prenom': surname ?? '',
        'accreditation-media': media ?? '',
        'accreditation-fonction': fonction ?? '',
        'accreditation-telephone': phone ?? '',
        'accreditation-email': email ?? '',
        'accreditation-evenement': accreditationEvenement ?? '',
        'accreditation-evenement-title': accreditationTitle ?? '',
        'accreditation-objet': object ?? '',
        _wpcf7_unit_tag: formId
      };

      postContactForm(formData, formId);
    } else {
      this.setState({
        error: 'Veuillez vérifier le contenu du formulaire',
        name: name === null ? '' : name,
        surname: surname === null ? '' : surname,
        media: media === null ? '' : media,
        fonction: fonction === null ? '' : fonction,
        phone: phone === null ? '' : phone,
        email: email === null ? '' : email,
        evenements: evenements === null ? [] : evenements,
        object: object === null ? '' : object
      });
    }
  };

  _getFormId = () => {
    const { contactForm } = this.props;

    if (contactForm && contactForm.length > 0) {
      const accreditationForm = contactForm.filter(form => form.title === 'accreditation');

      if (accreditationForm && accreditationForm.length > 0) {
        return accreditationForm[0].id;
      }
    }

    return 0;
  };

  render() {
    const { fetchStatus, sendStatus, accreditations } = this.props;
    const accreditationsFinal =
      accreditations.length > 0
        ? accreditations
        : [
            // { label: 'Biarrit7s', value: 'Biarrit7s' },
            // { label: 'Paris7s', value: 'Paris7s' },
            { label: 'Media Launch Biarritz', value: 'Media Launch Biarritz' },
            { label: 'Finales Féminines amateur', value: 'Finales Féminines amateur' },
            // { label: 'Annonce du Groupe Coupe du Monde', value: 'Annonce du Groupe Coupe du Monde' },
            { label: 'Congrès du Centenaire', value: 'Congrès du Centenaire' }
          ];
    const { isTouched, object, name, surname, media, fonction, phone, email, evenements, error } = this.state;

    if (fetchStatus !== STATUS_SUCCESS) {
      return <Loading isWhite />;
    }

    if (accreditations.length === 0) {
      return (
        <p>
          <em>{`Aucun évènement disponible pour une demande d'accréditation.`}</em>
        </p>
      );
    }
    const classNamesSend = dynamicClassName('btn btn--primary js-contact-send');
    sendStatus === STATUS_LOADING && classNamesSend.add('is-disabled');

    return (
      <div className="form-contact block-contact__form" style={{ display: 'block' }}>
        <h3 className="mb-1">Votre demande</h3>
        <form action="#">
          <TextInputMaterial id="object" isLight label="Objet de ma demande" disable defaultValue={object} />
          <TextInputMaterial
            id="name"
            isLight
            label="Nom*"
            errorMessage="Ce champ est requis"
            hasError={name !== null && name.length === 0}
            onChange={(value: string) => this._handleChange('name', value)}
          />
          <TextInputMaterial
            id="surname"
            isLight
            label="Prénom*"
            errorMessage="Ce champ est requis"
            hasError={surname !== null && surname.length === 0}
            onChange={(value: string) => this._handleChange('surname', value)}
          />
          <TextInputMaterial
            id="media"
            isLight
            label="Média*"
            errorMessage="Ce champ est requis"
            hasError={media !== null && media.length === 0}
            onChange={(value: string) => this._handleChange('media', value)}
          />
          <SelectInput
            isLight
            placeholder="Fonction*"
            options={[
              { label: 'Photographe', value: 'Photographe' },
              { label: 'Presse écrite', value: 'Presse écrite' },
              { label: 'Web', value: 'Web' },
              { label: 'Radio', value: 'Radio' },
              { label: 'TV', value: 'TV' }
            ]}
            defaultValue={fonction}
            onChange={(value: string) => this._handleChange('fonction', value)}
            hasError={fonction === ''}
            errorMessage={'Ce champ est requis'}
          />
          <TextInputMaterial
            id="phone"
            isLight
            label="Numéro de téléphone*"
            errorMessage={email === '' ? 'Ce champ est requis' : "Ce numéro de téléphone n'est pas valide"}
            hasError={phone !== null && !validatePhone(phone)}
            onChange={(value: string) => this._handleChange('phone', value)}
          />
          <TextInputMaterial
            id="email"
            isLight
            label="Adresse mail*"
            errorMessage={email === '' ? 'Ce champ est requis' : "Cet e-mail n'est pas valide"}
            hasError={email !== null && !validateEmail(email)}
            onChange={(value: string) => this._handleChange('email', value)}
          />
          {/* ffr-national@apsulis.com */}
          <DropdownMultiInput
            isLight
            label="Événements*"
            options={accreditationsFinal}
            selected={evenements}
            inputChanged={(value: string) => this._handleChange('evenements', value)}
            hasError={isTouched && evenements && !evenements.length}
            errorMessage={'Ce champ est requis'}
            className="dropdown dropdown--accordion mb-3 checkbox--form-accreditation"
          />

          <div className="form-action">
            <div>
              {error ? (
                <p>
                  <span>{error}</span>
                </p>
              ) : (
                sendStatus === STATUS_SUCCESS && (
                  <p>
                    <span style={{ color: '#4CB848', fontSize: '18px' }}>Votre demande a bien été envoyée</span>
                  </p>
                )
              )}
              <p className="ft-tertiary">* champs obligatoires</p>
            </div>
            <div>
              <button className="btn btn--primary js-contact-send" type="button" onClick={this.handleSubmit}>
                Envoyer ma demande
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ContactFormAccreditations;
